export function assignDevSigninURL(devSigninURL) {
  if (!devSigninURL || typeof window === 'undefined') return

  try {
    const url = new URL(devSigninURL)
    if (url.host !== window.location.host) {
      url.protocol = window.location.protocol
      url.host = window.location.host
    }
    window.location.assign(url.toString())
  } catch {
    window.location.assign(devSigninURL)
  }
}

/**
 * @returns {'redirect' | 'email' | false}
 */
export async function submitLoginEmail(email) {
  const response = await fetch('/api/login', {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  if (!response.ok) return false

  const data = await response.json().catch(() => null)
  if (data?.devSigninURL) {
    assignDevSigninURL(data.devSigninURL)
    return 'redirect'
  }

  if (data?.emailSent) {
    return 'email'
  }

  return false
}
